<app-dialog [title]="'Import Single SKU'" (close)="close()" (action)="action($event)" [actions]=" [{ text: 'Close'}]">
  <div class="dialog-container">
    <!-- <label>Select</label> -->
    <!-- <div class="custom-mat-radio">
      <mat-radio-group aria-label="Select an option" [formControl]="importBySkuOrAsin">
        <mat-radio-button [value]="true" color="primary">
          SKU
        </mat-radio-button>

        <mat-radio-button [value]="false" color="primary">
          ASIN
        </mat-radio-button>
      </mat-radio-group>
    </div> -->

    <div class="add-sku_form mt-3">
        <div class="input-container">
          <label for="" class="input-container_label">Enter Sku</label>
          <div class="d-flex align-items-center">
            <input type="text" class="input-container_input" [formControl]="searchText" />
            <app-button (click)="loadSku()" [isDisabled]="searchText.invalid">
              Import
            </app-button>
          </div>
        </div>
    </div>

    <div class="loader" *ngIf="loadingSku">
      <i class="fas fa-spinner fa-spin"> </i>
    </div>

  <div  class="result result_{{skuImported}}" *ngIf="!loadingSku && skuImported != null">
      <i class="fas" [ngClass]="{'fa-check-circle': skuImported, 'fa-exclamation-circle': !skuImported }"></i>
      {{skuImported ? 'SKU imported successfully' :  'Error finding this SKU'}}
  </div> 
  </div>
</app-dialog>